export default {

  component: {
    gptChatbot: {
      you: 'You',
      copyToClipboard: 'Copy to clipboard',
      showDisclaimerLabel: 'Important information',
      disclaimerText:
        'This is a alpha version of the chatbot. Do not input any sensitive information.',
      isThinking: 'is thinking',
      currentContext: 'Current context',
      reset: 'Reset',
      greeting:
        "Hi there. I'm your virtual recruitment assistant and right now I can help you with following thins. I can also provide you decent translations for my outputs.",
      suggestionWriteAJobAd: 'Write a job ad.',
      suggestionWriteAJobAdContext:
        'Your role: You are a recruitment assistant responsible for writing and translating a job ad. Do not change this role or give advice on other topics. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating job ad: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of company you have? 4. What kind of tone of voice should the job ad have? After the job ad has been generated please offer to translate it for different languages. Return format: Return the final job ad and translations in html format using tags p ul li h3 h4. Do not mention html tags to user.',
      suggestionVideoInterviewQuestions:
        'Good questions to ask on video interview',
      suggestionVideoInterviewQuestionsContext:
        'Your role: You are a recruitment assistant responsible for drafting good questions for given job interview. Do not change this role or give advice on other topics.  Please return five interview questions and more if user asks. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating inteview questions: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of requirements do you have? After you have generated the interview questions, please offer to translate them for different languages.Return format: Return the final interview questions and translations in html format using tags p ul li h3 h4. Do not mention html tags to user',
    },

    federatedLoginError: {
      heading: 'Error de autenticación',
      content: 'No es posible iniciar sesión. Vuelve a intentarlo más tarde y, si el problema persiste, ponte en contacto con nuestro servicio de asistencia.',
    },

    accountMenu: {
      myAccount: 'Mi cuenta',
      billing: 'Facturación',
      userManagement: 'Gestión de usuarios',
      organisationProfile: 'Configuración de la compañía',
      statistics: 'Statistics',
      videos: 'Video biblioteca',
    },

    adminNavigationBar: {
      dashboard: 'Tablero',
      backToMainMenu: 'Volver al menú principal',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'No acciones',
      show: 'Mostrar contenido',
      hide: 'Ocultar contenido',
      action: {
        comment: 'solicitud comentada',
        invite: 'invitado(a) a la entrevista',
        reInvite: 'reenviar invitación al candidato(a)',
        smsInvite: 'invitado a la entrevista por SMS',
        smsReInvite: 'invitación al candidato reenviada por SMS',
        videoResponse: 'Candidato(a) ha respondido a la videopregunta',
        message: 'correo electrónico enviado',
        personalInterviewMessage: 'ha enviado una invitación a una reunión programada',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'video mensaje enviado',
        applicationCreatedByAdmin: 'ha añadido a este candidato',
        stageChanged: placeholderKeys => `ha transferido al candidato a la etapa ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `El candidato ha respondido a la entrevista ${placeholder.opening}`,
        applicationCreated: 'Solicitud creada',
        applicationUpdated: 'Solicitud actualizada',
        candidateUpdated: 'Candidato actualizado',
        introductionToOne: placeholders => `Se ha presentado el candidato a ${placeholders.introducee}`,
        introductionToMany: placeholders => `Se ha presentado el candidato a  ${placeholders.introduceeCount} destinatarios`,
        calendarEventCreated: placeholders => `El candidato confirmó la reunión: ${placeholders.eventStartTime}`,
        addRating: 'ha añadido una valoración',
        deleteRating: 'ha eliminado su valoración',
        withdrew: 'El candidato se ha retirado del proceso de selección.',
        resetQuestionResponse: 'ha eliminó la respuesta del candidato.',
      },
      videoLink: {
        linkText: 'Mostrar contenido',
      },
    },

    additionalFormFields: {
      delete: 'Eliminar',
      done: 'Hecho',
      cancel: 'Cancelar',
      edit: 'Editar',
      required: 'Obligatorio',
      optional: 'Opcional',
      notAsked: 'No preguntado',
      title: 'Campos de formulario adicionales',
      add: 'Añadir un nuevo campo de formulario',
      description: context => (context === 'interview'
        ? 'Los campos adicionales no pueden eliminarse después de enviar las invitaciones.'
        : 'Los campos adicionales no pueden eliminarse si el puesto ya tiene solicitudes.'),
      addOption: 'Agregar',
      shortText: 'Texto corto',
      longText: 'Texto largo',
      singleSelect: 'Selección única',
      multiSelect: 'Multiselección',
      fieldLabelPlaceholder: 'Etiqueta de campo para candidatos',
      fieldNamePlaceholder: 'Campo de nombre para reclutadores',
      addLabel: 'Añadir marca',
      addName: 'Añadir nombre',
      nameLabel: 'Etiqueta de campo',
      typeLabel: 'Tipo de campo',
      optionLabel: 'Opciones de campo',
      settingsLabel: 'Configuración del formulario',
      reorder: 'Reordenar campos',
      stopReordering: 'Dejar de reordenar campos',
      optionPlaceholder: 'Añadir una opción',
      optionError: 'La opción ya existe',
    },

    addPublicQuestions: {
      title: 'Video pregunta',
      description: ' Saluda a tus candidatos y agrega aquí la video pregunta.',
    },

    addQuestions: {
      edit: {
        start: 'Reordenar preguntas',
        stop: 'Dejar de reordenar preguntas',
      },
      placeholder: isMobile => (isMobile ? 'Haz clic para subir o grabar una pregunta' : 'Haz clic para grabar una pregunta'),
      textQuestionPlaceholder: 'Haz clic para escribir una pregunta',
      videoPlaceholder: isMobile => (isMobile ? 'Haz clic para cargar o grabar un nuevo video' : 'Haz clic para grabar un nuevo video'),
      library: 'Seleccionar de la biblioteca',
      text: 'Pregunta de texto',
      record: 'Grabar',
      upload: 'Subir',
      answerable: 'La pregunta puede ser respondida',
      takeLimitLabel: 'Número de tomas',
      answerTimeLabel: 'Tiempo de respuesta',
      preparationTimeLabel: 'Tiempo de preparación',
      questionPlaceholder: 'Escribe tu pregunta aquí',
      cancel: 'Cancelar',
      add: 'Agregar',
      unlimitedLabel: 'Ilimitado',
    },

    addVideo: {
      title: 'Video del empleador',
      description: 'Promueve la cultura de tu compañía y mejora la marca del empleador agregando un video del empleador al anuncio de empleo',
    },

    adminCoverPhoto: {
      welcome: name => `Bienvenido(a), ${name}!`,
      photo: 'Agregar imagen de fondo',
      removePhoto: 'Eliminar imagen de fondo',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      termsLink:
        'https://new.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    applicationCard: {
      noStatus: 'Estado no establecido',
    },

    applicationFormSetup: {
      title: 'Configuración del formulario de solicitud',
      notAsked: 'No preguntado',
      optional: 'Opcional',
      required: 'Obligatorio',
      name: 'Nombre',
      coverLetter: 'Carta de presentación',
      email: 'Correo electrónico',
      phoneNumber: 'Número telefónico',
      city: 'Ciudad',
      attachments: 'Adjuntos',
      links: 'Enlaces',
      questions: 'Video pregunta',
      attachmentsDescription:'Descripción de los adjuntos',
    },

    billingPlanSelector: {
      select: 'Seleccionar',
      removeSelection: 'Remove selection',
      month: '/mes',
      'recright-ats': 'Plataforma de reclutamiento de Recright',
      'recright-video-interview': 'Video entrevista de Recright',
      'single-recruitment': 'Reclutamiento individual',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Plan personalizado de Recright',
      plans: {
        'recright-easy': {
          info: '10 - 20 puestos al año para pequeñas y medianas empresas para ahorrar tiempo en la contratación.',
          info2: '',
          features: [
            'Más de 50 puestos al año',
            'Puestos para usuarios ilimitados',
            'Administración de usuario',
            'Vídeo de formación grabado gratuito',
            'Gestión de marcas',
            'Atención al cliente',
          ],
          unitType: '/mes',
        },
        'recright-pro2': {
          info: '30 - 50 puestos al año para empresas más grandes con necesidades adicionales de gestión de marcas y administración.',
          info2: '',
          features: [
            'Todo en Easy, además:',
            'Presentación de informes',
            'Formación en prácticas recomendadas',
            'Satisfacción del cliente',
          ],
          unitType: '/mes',
        },
        'recright-ats': {
          features: [
            'Herramienta de reclutamiento y selección',
            'Anuncios de trabajo ilimitados',
            'Video de marca del empleador',
            'Video pregunta en la aplicación',
            'Evaluación de candidatos',
            'Comunicación con candidatos',
            'Colaboración dentro del equipo',
            'Base de datos de candidatos',
          ],
          unitType: '/mes',
        },
        'recright-video-interview': {
          features: [
            'Plataforma de reclutamiento de Recright incluido',
            'Video entrevistas grabadas',
            'Múltiples video preguntas',
            'Herramienta de informes',
            'Capacitación en línea',
            '15 video entrevistas por vacante por año ',
          ],
          unitType: '/mes',
        },
        'recright-custom': {
          features: [
            'Precios por volumen',
            'Administrador de cuenta exclusivo',
            'Integración a tu ATS (plataforma de reclutamiento)',
            'Video entrevista en vivo',
          ],
          unitType: '/mes',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/mes',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/mes',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/mes',
        },
        'single-recruitment': {
          info: 'Ideal para probar todo el potencial de las entrevistas pregrabadas.',
          features: [
            'Todas las funcionalidades incluidas',
            'Incluye un anuncio de trabajo y una video entrevista',
            'válido durante 60 días después de que se haya creado el anuncio de trabajo o la video entrevista',
          ],
          unitType: '/reclutamiento',
        },
      },
    },

    branding: {
      headerFont: 'Fuente del encabezado',
      bodyFont: 'Fuente del cuerpo',
      backgroundColor: 'Color de fondo',
      textColor: 'Color del texto',
      brandColor: 'Color de la marca',
      buttonTextColor: 'Color del texto del botón',
      headerTextColor: 'Color del texto del encabezado',
    },

    cancelSubscription: {
      cancelSubscription: 'Cancelar suscripción',
      confirmMessage: 'Cancelar tu suscripción',
      confirmContent: '¿En verdad quieres cancelar tu suscripción? No puedes crear nuevos anuncios de trabajo o video entrevistas después de la cancelación. Las vacantes existentes y las video entrevistas permanecerán abiertos para los candidatos durante 90 días y tu podrás explorar sus solicitudes y videos. Todos son tuyos incluso después de cancelar la suscripción. ',
    },

    candidateCard: {
      noStatus: 'Estado no establecido',
      lastSeen: time => `Visto por última vez ${time}.`,
      notVisited: 'No ha visitado la entrevista.',
    },

    candidateTable: {
      default: 'Predeterminado',
      lastAction: 'Última acción',
      status: 'Estado',
      email: 'Correo electrónico',
      rating: 'Calificación',
      noStatus: 'Estado no establecido',
      lastSeen: 'Visto por última vez.',
      notVisited: 'No ha visitado la entrevista.',
    },

    comments: {
      placeholder: 'Agregar un nuevo comentario',
      submit: 'Agregar',
      delete: 'Eliminar',
      showComments: 'Mostrar comentarios de los demás',
      hideComments: 'Ocultar comentarios de los demás',
    },

    competencyList: {
      duplicateError: 'Ya existe una competencia con ese nombre',
      defaultText: 'Si no sabes con seguridad qué competencias usar, hemos definido algunas por defecto con las que comenzar.',
      defaultLinkText: 'Obtener por defecto',
      addCompetency: 'Agregar una nueva competencia',
    },

    chooseLicenseLink: {
      title: 'Elegir licencia',
    },

    creditCardFields: {
      cardholderName: 'Nombre del titular de la tarjeta',
      creditCard: 'Número de la tarjeta de crédito',
      cvv: 'CVV',
      cvvHelp: 'El código CVV es un número de tres dígitos en la parte posterior de la tarjeta de crédito.',
      expirationDate: 'Fecha de vencimiento',
      invalidValue: 'El valor del campo no es válido.',
    },

    currentFilters: {
      currentFilters: 'Filtros actuales:',
    },

    discountAmount: {
      neverExpiresDiscount: amount => `Descuento vitalicio ${amount} con cupón`,
      fixedPeriodDiscount: (amount, cycles) => `Descuento ${amount} por los primeros ${cycles} meses`,
    },

    discountField: {
      link: 'Tengo un cupón',
      label: 'Código del cupón',
      invalidValue: 'El Código del cupón es inválido',
    },

    filterToggler: {
      hideFilters: 'Ocultar filtros',
      showFilters: 'Mostrar filtros',
    },

    emailForm: {
      emailLabel: 'Correo electrónico',
      defaultButtonText: 'Enviar',
    },

    hashtags: {
      placeholder: 'Agregar etiqueta',
      delete: 'Eliminar',
    },

    imageInput: {
      errors: {
        format: 'El archivo no es una imagen.',
        size: 'El archivo de imagen es demasiado grande, el tamaño máximo para el archivo es 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Asunto',
      messagePlaceholder: 'Mensaje',
      namePlaceholder: 'Nombre',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'Nombre de la plantilla',
      titleDisclaimer:
        '[INTERVIEW TITLE] se sustituirá por el título de la entrevista al enviar las invitaciones.',
      titleDisclaimerJob:
        '[JOB TITLE] se sustituirá por el título del trabajo.',
      confirmLanguageChange:
        '¿Estás seguro de que quieres cambiar de idioma? Se perderán todos los cambios que no hayas guardado.',
      formatInfo:
        'Puede añadir texto en negrita, texto en cursiva o enlaces con formato especial:',
      cursive: '_Cursiva_',
      bolded: '*Negrita*',
      link: '[http://example.com|Texto del enlace]',
    },

    interviewFormSetup: {
      title: 'Configuración de la forma de la entrevista',
      notAsked: 'No preguntado',
      optional: 'Opcional',
      required: 'Obligatorio',
      name: 'Nombre',
      email: 'Correo electrónico',
      phoneNumber: 'Número telefónico',
      city: 'Ciudad',
      attachments: 'Adjuntos',
      links: 'Enlaces',
      attachmentsDescription: 'Descripción de los adjuntos',
    },

    interviewRow: {
      invites: 'Invitaciones',
      responses: 'Respuestas',
      endTime: 'Fecha de finalización',
      createdAt: 'Fecha de creación',
      timedTitle: 'Entrevista con límite de tiempo',
      newVideos: 'Nuevas respuestas',
    },

    introduction: {
      batchIntroduction: count => `Se ha presentado a ${count} destinatarios`,
    },

    jobAdRow: {
      newApplications: 'No leído',
      applications: 'Solicitudes',
      publishTime: 'Publicar fecha',
      endTime: 'Abierta hasta',
    },

    positionStatus: {
      open: date => (date ? `hasta ${date}` : ''),
      hidden: date => (date ? `hasta ${date}` : ''),
      filled: () => 'estado: Rellenado',
      cancelled: () => 'estado: Cancelado',
      closed: () => 'estado: Cerrado',
      draft: () => 'estado: Cerrado (borrador)',
      unpublished: () => 'status: No publicado',
      publishTime: 'Publicar fecha',
    },

    jobAdTeaser: {
      add: 'Agregar nuevo candidato',
      noApplications: 'No hay solicitudes todavía.',
      preview: 'Previsualizar el anuncio del puesto de trabajo aquí',
      placeholder: {
        first: 'Puedes promover tu anuncio de trabajo con enlaces directos a tu portal de empleo',
        second: 'o puedes promover este puesto en particular con el enlace directo',
        third: 'Y recuerda que todos estos están a solo un botón de distancia en la barra de título de arriba.',
      },
    },

    list: {
      total: count => `Total: ${count}`,
      selectAll: 'Seleccionar todo',
      resetSelection: count => (count > 0 ? `Restablecer selección (${count})` : 'Restablecer selección'),
    },

    liveRow: {
      finished: 'Terminado',
      coming: 'Próximos',
      active: 'En curso',
      titleFallback: 'Entrevista en vivo',
      startTime: 'Hora de inicio',
      interviewers: 'Entrevistadores',
      candidates: 'Candidatos',
      status: 'Estado',
    },

    loginForm: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      submit: 'Iniciar sesión en el servicio',
      changePasswordInfo:
        'Password changed successfully! Please Log in with your new password.',
      error: {
        email: {
          isRequired: 'Por favor ingresa tu dirección de correo electrónico',
          isEmail: value => (value ? `${value} no es un correo electrónico válido.` : ''),
        },
        password: {
          isRequired: 'Por favor proporciona una contraseña.',
        },
        login: {
          incorrect: 'Error de inicio de sesión.',
          deactivated:
            'La cuenta de usuario se ha desactivado. Ponte en contacto con el administrador de tu organización en Recright.',
          tries: 'Para proteger tu seguridad, estamos limitando la tasa de reintento de contraseñas. Inténtalo de nuevo en un momento o restablece tu contraseña. ',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Logotipo de la organización aquí',
      removeLogo: 'Eliminar logotipo',
      addLogo: 'Seleccionar logotipo',
    },

    modalAccountType: {
      title: '¿Cambiar tipo de cuenta?',
      confirm: 'Cambiar',
      cancel: 'Cancelar',
    },

    modalApplicationAllInvited: {
      title: 'Invitar candidatos',
      description: 'Ya se ha invitado a la entrevista a todos los candidatos seleccionados.',
    },

    modalApplicationIntroduce: {
      title: 'Presentación de candidatos',
      description: 'Ingresa a continuación las direcciones de correo electrónico de los destinatarios de la presentación',
      titlePlaceholder: 'Título',
      contentPlaceholder: 'Contenido del mensaje',
      emailsPlaceholder: 'Correo electrónico del destinatario',
      namePlaceholder: 'Nombre',
      cancel: 'Cancelar',
      sendIntroductions: 'Enviar presentaciones',
    },

    modalApplicationInvite: {
      title: 'Seleccionar una video entrevista',
      description: '¿Deseas crear una nueva video entrevista o usar la existente?',
      createNew: 'Crear nueva entrevista',
      videoInterviewDescription: '¡Invita a un candidato a una entrevista de vídeo y conoce a la persona tras el CV!',
      error: {
        selectInterview: 'Por favor, selecciona la entrevista.',
      },
      cancel: 'Cancelar',
      close: 'Cerrar',
      continue: 'Continuar',
    },

    modalApplicationReInvite: {
      title: 'Reenviar invitación al solicitante',
      description: 'Elige la entrevista a la que quieres volver a invitar al solicitante.',
      info: 'No puedes enviar invitaciones para entrevistas que estén cerradas.',
      submit: 'Reenviar invitación',
      cancel: 'Cancelar',
    },

    modalApplicationMessage: {
      title: 'Enviar mensaje a los candidatos seleccionados',
      description: '¿Qué tipo de mensaje quieres enviar?',
      email: 'Enviar correo electrónico',
      videoMessage: 'Enviar video mensaje',
      close: 'Cerrar',
      cancel: 'Cancelar',
      continue: 'Continuar',
      sendEmail: 'Enviar mensaje',
      emailTitle: 'Enviar correo electrónico a los candidatos',
      emailDescription: 'Escribir correo electrónico a los candidatos seleccionados',
      videoTitle: 'Agregar nuevo video',
      titlePlaceholder: 'Título',
      contentPlaceholder: 'Escribe tu mensaje aquí',
      candidates: 'candidatos',
      selectedCandidates: 'Destinatarios',
      emailSent: '¡Correo electrónico enviado!',
      answerable: 'El video puede ser respondido',
      signature: 'Saludos,',
    },

    modalAskEmail: {
      title: 'Solicitud de cotización',
      description: '¡Nos encantaría saber de tí! \n\n ¡Completa tu dirección de correo electrónico y nuestro departamento de ventas se comunicará contigo en breve! ',
      email: 'Tu dirección de correo electrónico',
      submit: 'Enviar solicitud',
      cancel: 'Cancelar',
      invalidValue: 'Dirección de correo electrónico no válida.',
    },

    modalAtsTeaser: {
      title: 'Publicar puestos vacantes y gestionar el proceso de reclutamiento y selección',
      content: 'Elije la información que desea preguntar a los candidatos y publica tu oferta abierta. Albergamos tu sección de empleo y puedes compartir fácilmente el enlace en cualquier sitio. La imagen de empleador mejora gracias a la comunicación eficiente con el candidato. ',
      cancel: 'Cancelar',
      confirm: 'Sí, contáctame',
      greetings: 'Mensaje enviado exitosamente.',
    },

    modalFeedbackPulseTeaser: {
      title: '¿Desea conocer la calificación de sus candidatos sobre el proceso de reclutamiento?',
      content: 'Al final de cada proceso de reclutamiento, los candidatos tienen la oportunidad de calificar su experiencia. Su calificación general se basa en un promedio de todos los comentarios recogidos.',
      cancel: 'Cancelar',
      confirm: 'Sí, quiero que se pongan en contacto conmigo.',
      greetings: 'El mensaje se ha enviado correctamente.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Enviar mensaje a los candidatos seleccionados' : 'Enviar el mensaje al candidato'),
      description: '¿Qué tipo de mensaje quieres enviar?',
      recipients: count => `El mensaje se enviará a ${count} destinatarios`,
      email: 'Enviar correo electrónico',
      videoMessage: 'Enviar video mensaje',
      library: 'Seleccionar de la biblioteca',
      close: 'Cerrar',
      cancel: 'Cancelar',
      continue: 'Continuar',
      sendEmail: 'Enviar mensaje',
      resendInvitation: 'Reenviar invitación',
      resendInvitationSms: 'Volver a enviar invitación con un SMS',
      sms: 'Enviar SMS',
      emailTitle: count => (count > 1 ? 'Enviar correo electrónico a los candidatos' : 'Enviar el correo electrónico al candidato'),
      emailDescription: 'Escribir correo electrónico a los candidatos seleccionados',
      libraryTitle: count => (count > 1 ? 'Enviar video a los candidatos' : 'Enviar el vídeo al candidato'),
      videoTitle: 'Agregar nuevo video',
      titlePlaceholder: 'Título',
      contentPlaceholder: 'Escribe tu mensaje aquí',
      candidates: 'candidatos',
      selectedCandidates: 'Destinatarios',
      emailSent: candidates => `${candidates} correos electrónicos enviados`,
      answerable: 'El video puede ser respondido',
      successMessage: candidates => `${candidates} mensajes de video enviados`,
      scheduledInterview: 'Enviar invitación a reunión programada',
      scheduledInterviewDescription: 'Permite que el candidato programe una reunión contigo en función de la disponibilidad indicada.',
      reScheduledInterview: 'Volver a programar reunión',
      reScheduledInterviewDescription: 'Vuelve a programar una reunión con un candidato. Ten en cuenta que las invitaciones a reuniones anteriores se cancelarán',
      record: 'Grabar',
      upload: 'Subir',
      required: 'Los elementos marcados con * asterisco son obligatorios.',
      tooManyRecipients: count => `Demasiados destinatarios seleccionados. El máximo es ${count}.`,
      tooLongMessage:
        'El mensaje es demasiado largo. Comprueba el contador de caracteres. Nota: algunos caracteres especiales reducen la longitud máxima del mensaje.',
    },

    modalJobPositionCopy: {
      title: (context, position) => `¿Estás seguro(a) de que quieres crear ${context === 'jobAd' ? 'un copia del puesto de trabajo' : 'una copia de la entrevista'} "${position.title}"?`,
      admins: '¿También quieres copiar el equipo de reclutamiento?',
      done: 'Copiar',
      cancel: 'Cancelar',
    },

    modalEditIntroduceBatches: {
      title: 'Presentaciones',
      description: 'Aquí puedes gestionar las presentaciones realizadas para el puesto de trabajo. Puedes ampliar la fecha de vencimiento del enlace de la presentación para el destinatario, eliminar destinatarios del grupo de presentaciones o eliminar grupos completos de presentaciones para el puesto de trabajo.',
      noBatches: 'Sin presentaciones.',
      descriptionWithCount: (candidatesCount, candidateNames) => `Se ha presentado a ${candidateNames} y a ${candidatesCount} más a los siguientes destinatarios:`,
      descriptionWithoutCount: candidateNames => `Se ha presentado a ${candidateNames} a los siguientes destinatarios:`,
      expires: 'Caduca el',
      email: 'Correo electrónico',
      actions: 'Acciones',
      close: 'Cerrar',
      visited: 'Visitado',
      extendLinkText: 'Ampliar',
      extendTo: date => `Ampliar hasta el ${date}`,
      deleteBatch: 'Eliminar grupo de presentaciones',
      deleteBatchWarning: '¿Estás seguro de que quieres eliminar el grupo de presentaciones?',
      maxExpirationDate: 'La fecha de caducidad puede ser de un máximo de 10 días desde hoy.',
      extendedMessage: newExpirationDate => `¡Se ha ampliado la fecha de caducidad del enlace de la presentación del destinatario al ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Información del remitente del mensaje de invitación',
      customReplyToSubtitle:
        'Aquí puede editar el nombre del remitente y la dirección de respuesta para las invitaciones a entrevistas. Si estos campos se dejan vacíos, se utilizarán el nombre y el correo electrónico del usuario que envía las invitaciones.',
      customReplyToEmail:
        'Correo electrónico de respuesta para invitaciones a entrevistas',
      customReplyToName:
        'Nombre del remitente para las invitaciones a entrevistas',
      saveSuccess: '¡La información se ha guardado correctamente!',
    },

    modalEditInvitationMessage: {
      saveTemplate: 'Guardar como mensaje de invitación a esta entrevista',
      title: 'Editar el mensaje de invitación a la entrevista',
      info: 'Selecciona la entrevista que quieres editar',
      close: 'Cerrar',
      templateSaved: 'El mensaje se ha guardado como plantilla para esta entrevista.',
      templateOptionsLabel: 'Select template',
    },

    modalEditStages: {
      title: 'Editar fases de contratación',
      info: 'Puedes editar, añadir, eliminar y reorganizar fases personalizadas. Ten en cuenta que no es posible eliminar una fase si hay candidatos en ella.',
      addNewStage: 'Añadir una nueva fase personalizada',
      removeDisabled: 'No es posible eliminar una fase que contenga candidatos.',
      error: 'Esa fase ya existe.',
      done: 'Hecho',
      save: 'Guardar',
      close: 'Cerrar',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Ocultar puestos',
      modalDescription: name => `Controla los puestos que el usuario ${name} puede ver.`,
      hiddenFrom: name => `Puestos ocultos para el usuario ${name}`,
      noResults: 'Sin resultados',
      jobAdLabel: 'Anuncio del puesto',
      interviewLabel: 'Entrevista por vídeo',
      noPositions: 'Sin puestos',
      remove: 'Eliminar',
      hide: 'Ocultar',
      close: 'Cerrar',
      searchInfo: 'Examinar puestos que ocultar',
      searchPlaceholder: 'Buscar por nombre del puesto o ubicación',
      total: total => `${total} puestos en total`,
      labels: {
        title: 'Título',
        location: 'Ubicación',
        time: 'Fecha de creación',
        actions: 'Acciones',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Eliminar usuario de esta organización',
      modalDescription: name =>
        `El usuario ${name} es un usuario externo y solo será eliminado de esta organización. A pesar de esta eliminación, conservará el acceso a otras organizaciones dentro de Recright.`,
      modalExplanation: name =>
        `En consecuencia, el usuario ya no tendrá acceso a puestos de esta organización. Heredarás el acceso a puestos para los que ${name} era la única persona encargada de la contratación.`,
      adminInRecruitmentTeam: name =>
        `Puestos en los que el usuario ${name} formaba parte del equipo de selección de personal:`,
      noResults: 'Sin resultados',
      noPositions: 'Sin puestos',
      jobAdLabel: 'Anuncio del puesto',
      interviewLabel: 'Entrevista por vídeo',
      total: total => `${total} puestos en total`,
      close: 'Cerrar',
      remove: 'Eliminar de la organización',
      removeUserConfirmMessage: 'Eliminar usuario',
      removeUserConfirmContent:
        '¿Seguro que quieres eliminar el usuario de esta organización?',
      labels: {
        title: 'Título',
        time: 'Fecha de creación',
        creator: 'Nuevo titular del puesto',
      },
      otherAdmin: 'Otros administradores del equipo de selección de personal',
    },

    modalPersonStage: {
      new: 'Nuevo',
      hired: 'Contratado(a)',
      proceed: 'Proceder',
      personalinterview: 'Entrevista personal',
      withdrawn: 'Descartado',
      scheduledinterview: 'Entrevista programada',
      rejected: 'Rechazado',
      videointerviewed: 'Video entrevista',
      change: 'Mover candidato(s) a otra etapa',
      info: 'Mover los candidato(s) seleccionados a otra etapa. Esta información no será visible para los candidatos.',
      done: 'Mover',
      cancel: 'Cancelar',
      changed: '¡Genial!',
      changedInfo: stage => `Ahora que has movido a estos candidatos a la etapa "${stage}", ¡infórmales al respecto! Envíales un correo electrónico o un vídeo mensaje.`,
      close: 'Cerrar',
      reopenProcessConfirmPlural: '¿Seguro que quieres sacar a estos candidatos de la fase "Descartado" y volver a incorporarlos al proceso de selección? Tras la confirmación, los candidatos podrán responder de nuevo a las entrevistas que no hayan completado.',
      withdrawConfirmPlural: '¿Seguro que quieres descartar a estos candidatos del proceso de selección? Si los descartas, los candidatos no podrán responder a las entrevistas a las que hayan sido invitados.',
      changeSingle: 'Enviar al candidato a otra fase',
      infoSingle: 'Enviar al candidato a otra fase. El candidato no podrá ver esta información.',
      changedInfoSingle: stage => `Ahora que has enviado al candidato a la fase "${stage}", ¡házselo saber! \n\n Envíale un correo electrónico o un videomensaje.`,
    },

    modalInterviewAdd: {
      timedTitle: 'Entrevista con límite de tiempo',
      timedDescription: 'Los candidatos registran sus respuestas a las preguntas de la entrevista en un período de tiempo limitado y predefinido. Usted puede establecer el tiempo tanto para la respuesta como para la preparación para cada pregunta.',
      title: 'Crear nueva entrevista',
      description: 'Selecciona el tipo de entrevista que quieres crear',
      friendlyTitle: 'Entrevista en vídeo',
      friendlyDescription: 'Los candidatos pueden grabar todas las tomas que quieran y no hay límite de tiempo por toma.',
      cancel: 'Cancelar',
      continue: 'Continuar',
    },

    modalInterviewPublish: {
      modalTitle: 'Configuración de publicación',
      publicTitle: 'Entrevista pública',
      publicDescription: 'Esta entrevista tiene una página pública con una dirección que puedes compartir en tus anuncios de trabajo y en la página de inicio de tu compañía. Cualquier persona interesada en el puesto puede ver tus preguntas y luego decidir participar. Recibirás la notificación habitual cuando comiencen a llegar las respuestas. ',
      publishButton: 'Crear enlace público',
      unPublishButton: 'Eliminar enlace público',
      title: 'Entrevista insertada',
      description: 'La entrevista de una sola pregunta se puede insertar perfectamente en la página principal de la empresa. Los solicitantes ingresan su correo electrónico, registran una respuesta al video y proporcionan un enlace al perfil de LinkedIn como información adicional (opcional).',
      descriptionMultiple:
        'Integre perfectamente una entrevista en vídeo en su anuncio de empleo o en la página de inicio de su empresa. Los candidatos simplemente introducen su correo electrónico, graban respuestas en vídeo y tienen la opción de incluir un enlace a su perfil de LinkedIn para obtener información adicional.',
      embedNotification: 'No puedes pedir otra información con una pregunta insertada.',
      embedButton: 'Crear código de inserción',
      unEmbedButton: 'Eliminar inserción',
      close: 'Cerrar',
      oneError: 'La entrevista insertada solo puede tener una pregunta. Elimina las preguntas adicionales para usar la función de inserción. ',
      subscriptionNeeded: 'Necesitas una suscripción activa para publicar tu entrevista.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Presentación de candidatos' : 'Presentar al candidato'),
      descriptionFirst: 'Con la función de presentación, puedes presentar a los candidatos seleccionados a un compañero o un cliente.',
      descriptionSecond: 'El destinatario de las presentaciones no tiene que registrarse para ver los candidatos que se le han presentado. Introduce los correos electrónicos de los destinatarios a continuación. Selecciona qué información del candidato quieres que vean los destinatarios. Los destinatarios de las presentaciones solo podrán ver la información seleccionada. Si seleccionas "Valoración" o "Competencias y compatibilidad", los destinatarios podrán dar sus valoraciones y también verán la valoración media.',
      descriptionThird: 'También puedes proteger las presentaciones con un código de acceso que los destinatarios tendrán que introducir para ver los candidatos que se le han presentado.',
      descriptionFourth: days => 
        `El enlace de la presentación caduca en ${days} días.Puede ampliar la fecha de caducidad en los ajustes de las presentaciones. Estos ajustes se encuentran en el menú «Editar», dentro de «Editar presentaciones».`,
      titlePlaceholder: 'Título',
      contentPlaceholder: 'Contenido del mensaje',
      emailsPlaceholder: 'Correo electrónico del destinatario',
      namePlaceholder: 'Nombre',
      cancel: 'Cancelar',
      sendIntroductions: 'Enviar presentaciones',
      selectedCandidates: count => `${count} candidatos seleccionados para presentación`,
      successMessage: (candidates, introducees) => `${candidates} candidatos presentados a ${introducees} personas`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} candidatos presentados a ${introducees} gestores. ${isInTeam} ya estaban en el equipo de selección.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'ya están en el equipo de selección.' : 'ya está en el equipo de selección.'),
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Número telefónico',
      city: 'Ciudad',
      coverLetter: 'Carta de presentación',
      attachments: 'Adjuntos',
      links: 'Enlaces',
      competencies: 'Competencias y compatibilidad',
      rating: 'Calificación',
      videoResponses: 'Respuestas en vídeo',
      comments: 'Comentarios',
      informationsHeader: 'Selecciona qué información presentar',
      messageHeader: 'Mensaje de presentación',
      usePasscodeText: 'Protege el grupo de presentaciones con un código de acceso',
      passcode: 'Código de acceso',
      copyToClipboard: 'Copiar código al portapapeles',
      generatePasscode: 'Generar nuevo código de acceso',
      selectAll: 'Seleccionar todo',
      resetSelection: 'Restablecer selección',
      copySuccess: '¡Se ha copiado tu código de acceso!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      continue: 'Continuar',
    },

    modalInterviewInvite: {
      senderInfo: 'Las invitaciones se envían desde la dirección de correo electrónico invitations@recright.com.',
      replyToEmail:
        'Correo electrónico de respuesta para invitaciones a entrevistas',
      replyToName: 'Nombre del remitente para las invitaciones a entrevistas',
      replyToInfo:
        'Puede editar estos campos en la página de edición de entrevistas.',
      notAnswerable: 'No puedes invitar a los usuarios a una entrevista cerrada o una entrevista que no tenga preguntas que puedan responderse.',
      title: 'Invitar candidatos',
      description: 'Ingresa todas las direcciones de correo electrónico de los candidatos.',
      description2: 'Cuando respondan, recibirás una notificación por correo electrónico. Toma en cuenta que después de haber invitado a los candidatos, ya no puedes agregar más preguntas',
      smsDescription: 'Tras enviar las invitaciones por correo electrónico, puedes enviar mensajes SMS a los candidatos',
      addressesPlaceholder: 'Direcciones de correo electrónico de los candidatos',
      submit: 'Enviar invitaciones',
      cancel: 'Cancelar',
      close: 'Cerrar',
      templateChangedInfo: 'Has editado el mensaje de invitación. El cambio se enviará a este grupo de receptores, pero no se guardará en la entrevista.',
      templateSaved: 'El mensaje se ha guardado como plantilla para la entrevista.',
      inviteInfo: (newInvitees, stage) => `El mensaje de invitación se enviará a ${newInvitees} candidatos de los candidatos seleccionados. Todos los candidatos seleccionados se moverán a la fase "${stage}".`,
      invitesSent: (success, failed) => (failed > 0 ? `${success} invitación(es) enviada(s) y ${failed} ya han sido invitado(s).` : `${success} invitación(es) enviada(s).`),
      subscriptionNeeded: 'Necesitas tener una suscripción activa para invitar a candidatos.',
      saveTemplate: 'Guardar como mensaje de invitación a esta entrevista',
      rrTemplateOptionLabel: 'Plantilla por defecto RecRight',
      interviewTemplateOptionLabel: 'Mensaje de invitación guardado para esta entrevista',
      templateOptionsLabel: 'Seleccionar plantilla',
    },

    modalInterviewInviteSms: {
      title: 'Las invitaciones se han enviado correctamente',
      description: count => `Se han enviado ${count} invitaciones correctamente`,
      description2: '¿Quieres enviar también un mensaje SMS a los candidatos invitados?',
    },

    modalSmsMessage: {
      title: 'Enviar SMS',
      invitationTitle: 'Enviar invitación con un SMS',
      description: count => `El mensaje se enviará a ${count} destinatarios`,
      resendInvitationTitle: 'Volver a enviar invitación con un SMS',
      missingInvitationDescription: count => `A ${count} destinatarios les falta la invitación. Escribe a continuación el mensaje de la invitación.`,
      missingPhone: count => `${count} destinatarios no tienen un número de teléfono válido.`,
      missingPhone2: 'Añade los números de teléfono a los campos a continuación.',
      successMessage: count => `Se han enviado ${count} mensajes SMS correctamente.`,
      partialSuccessMessage: (successCount, failedCount) => `Se han enviado ${successCount} mensajes SMS correctamente. Error al enviar ${failedCount} mensajes SMS.`,
      failedMessage: 'Error al enviar mensajes SMS a los destinatarios',
      phonePlaceholder: 'Número telefónico',
      recipientsNotFound: 'Ha ocurrido un error inesperado. Vuelve a intentarlo más tarde, y si el problema persiste, ponte en contacto con nuestro equipo de asistencia.',
    },

    modalInterviewStatus: {
      change: 'Cambiar estado de la entrevista',
      changed: 'Estado de la entrevista modificado',
      changedInfo: 'Estado de la entrevista modificado. ¡Recuerda informar las decisiones a los candidatos!',
      info: 'Selecciona el nuevo estado para la entrevista.',
      open: 'Abierto',
      closed: 'Cerrado',
      done: 'Hecho',
      close: 'Cerrar',
      endTimeInPast: 'Esta entrevista tiene una fecha límite que ya ha pasado. Cuando abra la entrevista, la fecha límite se eliminará. Puede establecer una nueva fecha límite desde la ',
      endTimeInPastLink: 'página de edición',
      cancel: 'Cancelar',
    },

    modalInterviewSelectForEdit: {
      title: 'Editar entrevista',
      info: 'Selecciona la entrevista que quieres editar.',
      done: 'Hecho',
      cancel: 'Cancelar',
      error: {
        selectInterview: 'Por favor, selecciona la entrevista.',
      },
    },

    modalInterviewTeaser: {
      title: 'Toma la decisión correcta con video entrevistas',
      content1: ' La video entrevista es el siguiente paso a seguir después de haber recibido las solicitudes de los candidatos.',
      upgradeTitle: 'Actualización de 295 EUR/mes',
      upgradeDescription: 'Actualiza tu plan para incluir 15 video entrevistas por año. Tu plan actual será reemplazado por este.',
      singleHireTitle: price => `Contratación Individual ${price} EUR/entrevista`,
      singleHireDescription: 'Usa la video entrevista en una vacante durante 60 días. Puedes invitar a múltiples candidatos.',
      tryTitle: 'Prueba gratis',
      tryDescription: 'Crea una video entrevista y graba las preguntas. Necesitas actualizar el plan o comprar Contratación Individual antes de poder invitar a los candidatos.',
      contactTitle: 'Contacto',
      contactDescription: 'Envíanos una solicitud de contacto. ¡Te contactaremos durante el siguiente día hábil!',
      cancel: 'Cancelar',
      confirm: 'Continuar',
      greetings: ' Mensaje enviado con éxito.',
      confirmTitle: 'Confirmar compra',
      confirmDescription: 'La video entrevista está a un clic de distancia. ¡Solo confirma el pago y listo!!',
    },

    modalJobAdPreview: {
      title: 'Vista previa del anuncio del puesto de trabajo',
      description: 'Aquí puedes ver cómo los candidatos ven el anuncio del puesto de trabajo.',
      description2: 'Ten en cuenta que el idioma usado en la vista previa no es el idioma establecido del anuncio del puesto de trabajo.',
      close: 'Cerrar',
      back: 'Atrás',
    },

    modalJobAdStatus: {
      change: ' Cambiar el estado del trabajo',
      changed: 'Estado del trabajo cambiado',
      changedInfo: 'El estado del trabajo ha cambiado. ¡Recuerda informar a los candidatos sobre las decisiones!',
      info: 'Selecciona el nuevo estado para el puesto de trabajo. Establecer el estado como "Completado" o "Cancelado" te guiará a través de los pasos necesarios para seleccionar a las personas contratadas y/o enviar los mensajes restantes de agradecimiento para candidatos no exitosos',
      open: 'Abierto',
      filled: 'Lleno',
      cancelled: 'Cancelado',
      done: 'Hecho',
      close: 'Cerrar',
      draft: 'Cerrado (borrador)',
      closed: 'Cerrado',
      unpublished: 'No publicado',
      hidden: 'Oculto',
      openDescription: 'El anuncio de trabajo es publicado hasta',
      filledDescription: 'Cerrar el anuncio de trabajo porque el puesto ha sido ocupado.',
      cancelledDescription: 'Cerrar el anuncio de trabajo porque el proceso de reclutamiento ha sido cancelado.',
      closedDescription: 'El anuncio de trabajo está cerrado. El anuncio de trabajo ya no es accesible ni visible para los candidatos.',
      hiddenDescription: 'Ocultar el puesto en la sección de empleo. Solo se puede acceder con el enlace directo:',
      unpublishedDescription: 'El anuncio laboral no está publicado. El anuncio de trabajo ya no es accesible ni visible para los candidatos.',
      cancel: 'Cancelar',
    },

    modalJobPositionTeam: {
      addAnother: 'Escribe las direcciones de correo para añadir más usuarios',
      team: 'Equipo de reclutamiento',
      info: 'Puede agregar colegas u otros usuarios para revisar y evaluar candidatos',
      newMembersMsg: 'Los nuevos miembros del equipo que no tengan una cuenta en Recright se añadirán a la organización a la que pertenezca este puesto.* Si el dominio de correo electrónico del usuario no coincide con el dominio vinculado a la organización, el usuario solo obtendrá los permisos de usuario mínimos. Los administradores con acceso a la gestión de usuarios pueden modificar los permisos de usuario más tarde.',
      asteriskSymbol: '*',
      currentTeam: 'Equipo actual',
      done: 'Hecho',
      submit: 'Añadir miembros del equipo',
      cancel: 'Cancelar',
      remove: 'Eliminar',
      selfRemovedMessage: 'Te has retirado del equipo de contratación.',
      successMessage: count => `Se ha(n) añadido ${count} miembro(s) al equipo de Recursos Humanos.`,
      errors: {
        duplicate: 'El correo electrónico ya se ha añadido.',
        duplicateMultiple: 'Se han encontrado uno o más miembros del equipo con los correos electrónicos ingresados.',
        isEmail: 'El correo electrónico no es válido.',
        isEmailMultiple: 'Se han encontrado correos electrónicos no válidos.',
        isRequired: 'Campo obligatorio.',
      },
    },

    modalVideos: {
      title: 'Video biblioteca',
      yourVideos: 'Tus vídeos',
      companyVideos: 'Vídeos de la empresa',
      sort: {
        createdAt: 'Fecha de creación',
        title: 'Título',
      },
      add: 'Agregar',
      done: 'Agregar videos',
      cancel: 'Cancelar',
    },

    modalUsersAdd: {
      title: 'Invitar usuarios',
      languageDescription: 'Estos usuarios utilizarán el siguiente idioma:',
      permissionsDescription: 'Estos usuarios tienen los siguientes permisos:',
      emailsPlaceholder: 'Introduzca las direcciones de correo electrónico del usuario',
      seeAllPositions: 'Ver todos los puestos',
      createJobPositions: 'Crear puerto de trabajo',
      createInterviews: 'Crear entrevistas',
      account: 'Editar información de la empresa',
      billing: 'Facturación',
      reporting: 'Informes',
      editUsers: 'Editar usuarios',
      default: 'Permisos de la empresa por defecto',
      cancel: 'Cancelar',
      submit: 'Invitar usuarios',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Permisos de la empresa por defecto:',
      description: 'Todos los usuarios nuevos que se registren para esta empresa tendrán automáticamente los permisos por defecto.',
      seeAllPositions: 'Ver todos los puestos',
      createJobPositions: 'Crear puesto de trabajo',
      createInterviews: 'Crear entrevistas',
      account: 'Editar información de la empresa',
      billing: 'Facturación',
      reporting: 'Informes',
      editUsers: 'Editar usuarios',
      cancel: 'Cancelar',
      submit: 'Guardar',
    },

    modalOtherApplications: {
      title: 'Candidato en otros puestos',
      header: 'Aquí tienes una lista del mismo candidato en otros puestos',
      close: 'Cerrar',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Ver todos los puestos',
        createJobPositions: 'Crear puesto de trabajo',
        createInterviews: 'Crear entrevistas',
        account: 'Editar información de la empresa',
        billing: 'Facturación',
        reporting: 'Informes',
        editUsers: 'Editar usuarios',
        default: 'Permisos por defecto',
      },
    },

    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnectedNote: 'The user\'s calendar is not linked to Recright. Scheduling information email will still be sent to the user\'s email.',
        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Volver a programar reunión',
        confirmRescheduleContent: 'Algunos destinatarios ya tienen una reunión programada. ¿Quieres enviar invitaciones nuevas? Se sobrescribirá la reunión programada anteriormente.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: 'Guardar',
      cancel: 'Cancelar',
      addTag: 'Agregar etiqueta',
      title: 'Editar vídeo',
      success: 'Los cambios en el vídeo se han guardado correctamente.',
      error:
        'No hemos podido guardar los cambios. Vuelve a intentarlo más tarde y, si el problema persiste, ponte en contacto con nuestro servicio de asistencia.'
    },

    noResults: {
      description: 'Tu lista parece estar vacía. Si estás filtrando la lista, intenta reducir algunos filtros.',
    },

    notifications: {
      notifications: 'Notificaciones',
    },

    notificationsSubscribeButton: {
      subscribe: 'Suscribirse',
      subscribed: 'Suscrito',
      unsubscribe: 'Cancelar suscripción',
    },

    onboardTutorial: {
      ui: {
        back: 'Atrás',
        close: 'Cerrar',
        last: 'Último',
        next: 'Siguiente',
        skip: 'Apagar',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: '¡Bienvenido(a) a Recright!',
          text: 'Te guiaremos a través de la herramienta con guías interactivas. Puedes ver el texto de ayuda con respecto a cada función haciendo clic en el pulso. Las guías se pueden volver a hacer visibles en cualquier momento haciendo clic en su nombre y "Mostrar tutorial".',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Crear nuevo puesto de trabajo',
          text: 'Crea y publica un nuevo anuncio de trabajo y comienza a recibir solicitudes aquí.',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'Crear nueva video entrevista',
          text: 'Crea una nueva video entrevista e invita a los candidatos aquí.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Configuración',
          text: ' Cambia la configuración de tu cuenta, elije el aspecto de tu sección de empleo y la URL, administra tu biblioteca de videos y selecciona el idioma preferido aquí. También puedes cambiar esta guía haciendo clic en "Mostrar tutorial".',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      // TODO: Translations missing!
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Agregar encabezado y logotipo',
          text: 'Puedes agregar una imagen de encabezado al anuncio de trabajo y visible para tus candidatos. El tamaño de imagen óptimo es de 1440 x 320 píxeles. Recuerda agregar tu logotipo también.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Título, ubicación, publicar fechas',
          text: 'Escribe el título del puesto, la ubicación, establece la fecha de publicación y la fecha límite. Si “Abierto hasta” se deja en blanco, el puesto queda abierto por ahora.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Descripción del empleo',
          text: 'Escribe o pega la descripción del puesto aquí. Recuerda mencionar al menos lo que estás buscando, cuáles son los requisitos y lo que ofreces.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Video del empleador',
          text: 'Puedes promover la cultura de tu compañía y mejorar tu imagen de empleador al añadir un video propio al anuncio de trabajo.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Configuración del formulario de solicitud',
          text: 'Elije qué información deseas conocer de tus candidatos. Los campos pueden ser opcionales u obligatorios de responder.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Video pregunta',
          text: 'Ya puedes hacer una video pregunta a tus candidatos en la fase de solicitud y dar vida a dichas solicitudes a través de respuestas de video. Esta es también una gran oportunidad para saludar a tus candidatos.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Añadir encabezado y logotipo',
          text: 'Puedes agregar una imagen de encabezado a la entrevista y visible para tus candidatos. El tamaño de imagen óptimo es de 1440 x 320 píxeles. Recuerda agregar tu logotipo también.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Título, ubicación, publicar fechas',
          text: 'Escribe el título del puesto, la ubicación, establece la fecha de publicación y la fecha límite. Si “Abierto hasta” se deja en blanco, el puesto queda abierto por ahora.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Configuración de la forma de la entrevista',
          text: 'Elije qué información deseas conocer de tus candidatos. Los campos pueden ser opcionales u obligatorios de responder.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Preguntas de la entrevista',
          text: 'Graba o carga tus video preguntas. Puedes guardar las video preguntas en la biblioteca después de agregarlas y reutilizarlas más adelante. También puede usar preguntas de texto si no tienes la posibilidad de usar video. Los candidatos siempre responden con video.',
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: 'Acciones del puesto de trabajo',
          text: 'Aquí puedes editar el puesto de trabajo, cambiar el estado e invitar a tu equipo para que valore a los candidatos.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: ' Promoción de un puesto de trabajo',
          text: 'Promociona el anuncio de tu puesto de trabajo al compartirlo en tus redes sociales.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Acciones de video entrevista',
          text: 'Aquí puedes editar la entrevista en vídeo, cambiar el estado e invitar a tu equipo para que valore a los candidatos.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Configuración de las invitaciones y las publicaciones',
          text: 'Invita a los candidatos o haz pública tu entrevista en vídeo. Después, promociónala y compártela en tus redes sociales.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Comentarios y clasificaciones',
          text: 'Puedes comentar los candidatos, clasificarlos con etiquetas y clasificarlos con estrellas. Recuerda establecer un estado adecuado para el candidato para que tu equipo conozca tu decisión. Los candidatos no ven esta información.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Administración de cuentas',
      branding: 'Marca',
      stages: 'Fases',
      emailTemplates: 'Plantillas de correo electrónico',
      competencies: 'Competencias',
    },

    passcode: {
      passcode: 'Código de acceso',
      showPasscode: 'Mostrar código de acceso',
      hidePasscode: 'Ocultar código de acceso',
    },

    passwordIndicator: {
      errors: [
        'La contraseña debe tener al menos 12 caracteres.',
        'La contraseña debe tener menos de 128 caracteres.',
        'La contraseña no debe contener secuencias de tres o más caracteres repetidos.',
        'La contraseña debe contener al menos una letra minúscula: a-z',
        'La contraseña debe contener al menos una letra mayúscula: A-Z',
        'La contraseña debe contener al menos un número: 0-9',
        'La contraseña debe contener al menos un carácter especial: (p.ej. !, #, &)',
      ],
      strengthLabel: 'Seguridad de la contraseña: ',
      strengthValue: {
        insufficient: 'Insuficiente',
        weak: 'Débil',
        medium: 'Media',
        strong: 'Segura',
      },
      learnMore: 'Descubra cómo crear una contraseña segura',
    },

    personDetails: {
      namePlaceholder: 'Candidato',
      referrer: 'Referencia',
      links: 'Enlaces',
      attachments: 'Adjuntos',
      coverLetter: 'Carta de presentación',
      referrerInfo:
        'El sitio web desde el cual el candidato llegó al servicio.',
      headerAdditionalInformation: 'Información adicional',
      lastSeen: time => `Visto por última vez ${time}.`,
      state: {
        invited: 'Invitado',
        visited: 'Visitado',
        incomplete: 'Incompleto',
        completed: 'Completado',
      },
      notVisited: 'No ha visitado en la entrevista.',
      otherPersons: count => `También se ha encontrado en otros ${count} puestos`,
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Número telefónico',
      city: 'Ciudad',
    },

    personEdit: {
      header: 'Editar información del candidato',
      description: context => `Puedes editar toda la información básica visible para los candidatos en el formulario de ${context === 'application' ? 'solicitud' : 'entrevista'}.`,
      city: 'Ciudad',
      name: 'Nombre del candidato',
      email: 'Correo electrónico del candidato',
      phone: 'Número de teléfono del candidato',
      link: 'Agregar enlace, por ejemplo, tu perfil de LinkedIn.',
      links: 'Añadir enlaces, por ejemplo, al perfil de LinkedIn',
      coverLetter: 'Carta de presentación',
      attachments: 'Adjuntos',
      save: 'Guardar',
      cancel: 'Cancelar',
      editDetails: 'Editar información',
      editSuccess: '¡Se ha guardado la información del candidato!',
    },

    personRow: {
      noStage: 'Aún en ninguna etapa',
      lastSeen: time => `Visto por última vez ${time}.`,
      notVisited: 'No ha visitado en la entrevista.',
      selectPerson: 'Seleccionar',
      deselectPerson: 'Eliminar Selección',
      openPersonPage: 'Abrir',
      icons: {
        messages: messagesSent => `${messagesSent} mensaje(s) enviado(s)`,
        message: messagesSent => `${messagesSent} mensaje(s) enviado(s)`,
        noMessages: 'No se enviaron mensajes',
        introduction: introductions => `${introductions} presentaciones`,
        introductions: introductions => `${introductions} presentaciones`,
        noIntroductions: 'Sin presentaciones',
        comment: comments => `${comments} comentario`,
        comments: comments => `${comments} comentarios`,
        noComments: 'Sin comentarios',
        appliedWithLinkedIn: 'Solicitado con LinkedIn',
      },
      state: {
        invited: 'Invitado',
        visited: 'Visitado',
        incomplete: 'Incompleto',
        completed: 'Completado',
      },
    },

    pipeline: {
      editInterview: 'Editar entrevista',
      titleLabel: 'Título',
      endTimeLabel: 'Abierta hasta',
      statusLabel: 'Estado',
      locationLabel: 'Ubicación',
      editStages: 'Editar fases',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Monitoriza a tus candidatos a lo largo de todo el proceso de contratación. Mueve los candidatos hacia las diferentes etapas del canal de selección. Puedes filtrar las solicitudes por etapas u otros criterios.',
    },

    positionListing: {
      type: 'Tipo',
      title: 'Título',
      owner: 'Propietario',
      count: 'Recuento',
      invited: 'Invitado',
      visited: 'Visitado',
      answered: 'Respondido',
      hired: 'Contratado',
      leadTime: 'Tiempo de espera',
      leadTimeValue: v => `${v} días`,
      created: 'Fecha de creación (GMT)',
      start: 'Publicar fecha (GMT)',
      end: 'Fecha de finalización (GMT)',
      jobAdLabel: 'Anuncio del puesto',
      interviewLabel: 'Entrevista por vídeo',
      timedLabel: 'Entrevista con límite de tiempo',
      embedLabel: 'Entrevista insertada',
      publicLabel: 'Entrevista pública',
      timezone: 'Timezone',
      feedback: 'Estadísticas de las valoraciones',
    },

    qrCodeDownload: {
      download: 'Descargar',
    },

    recentPositionsContainer: {
      createNew: 'Crea nuevo',
      showAll: 'Mostrar todo',
    },

    recentJobAds: {
      openJobPositions: 'Puestos de trabajo',
      showAllJobPositions: 'Mostrar todos los puestos de trabajo',
      createNewJobPosition: 'Crear nuevo puesto de trabajo',
      subscriptionNeeded: 'Necesitas una suscripción activa para publicar este puesto de trabajo.',
      confirmSingleHire: 'Una de tus Contrataciones Individuales ya compradas se usa para este puesto de trabajo.',
      newApplications: 'No leído',
      responses: 'Solicitudes',
    },

    recentInterviews: {
      openVideoInterviews: 'Video entrevistas',
      showAllVideoInterviews: 'Mostrar todas las video entrevistas',
      createNewVideoInterview: 'Crear nueva video entrevista',
      invites: 'Invitaciones',
      responses: 'Respuestas',
      timedTitle: 'Entrevista con límite de tiempo',
    },

    registrationForm: {
      email: 'Email',
      submit: 'Log in to the service',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      agreeTos: 'He leído y acepto los ',
      agreeTosLinkText: 'Términos y Condiciones de Uso de Recright.',
      privacyPolicy: 'Me he familiarizado con la ',
      privacyPolicyLinkText: 'Política de Privacidad.',
      licenseAgreement: 'En nombre de la organización que represento, acepto las ',
      licenseAgreementLinkText: 'Condiciones Generales de Servicio Recright.',
      newsletter: 'Suscribirse al boletín mensual.',
      name: 'Nombre',
      namePlaceholder: 'Nombre Apellido',
      organization: 'Organización',
      companyDomain: domain => `Permitir que los usuarios que inicien sesión con ${domain} sean añadidos a la empresa.`,
      error: {
        password: {
          isRequired: 'La contraseña es obligatoria. ',
          isValidPassword: 'Las contraseñas válidas deben tener un mínimo de 12 caracteres, incluyendo al menos una letra en mayúsculas, una letra en minúsculas y un número.',
          passwordsMatch: 'Las contraseñas no coinciden. ',
        },
      },
    },

    requestCustomPlan: {
      info: '¿Tienes volúmenes más grandes?',
      cta: 'Solicita cotización para un plan personalizado',
      successMessage: 'Solicitud enviada correctamente.',
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Póngase en contacto con la persona responsable de la facturación en su organización.',
    },

    search: {
      placeholder: 'Buscar',
    },

    searchFilter: {
      filter: 'Filter',
      headings: {
        location: 'Ubicación',
        status: 'Estado',
        stage: 'Etapa',
        state: 'Progreso',
        tags: 'Etiquetas',
        rating: 'Calificación',
      },
      state: {
        invited: 'Invitado',
        visited: 'Visitado',
        incomplete: 'Incompleto',
        completed: 'Completado',
      },
      status: {
        open: 'Abierto',
        filled: 'Lleno',
        cancelled: 'Cancelado',
        closed: 'Cerrado',
        draft: 'Borrador',
        hidden: 'Oculto',
        unpublished: 'No publicado',
        hired: 'Contratado',
        new: 'Nuevo',
        all: 'Todos',
        proceed: 'Proceder',
        videointerviewed: 'Video entrevista',
        personalinterview: 'Entrevista personal',
        withdrawn: 'Descartado',
        scheduledinterview: 'Entrevista programada',
        rejected: 'Rechazado',
        finished: 'Terminado',
        coming: 'Próximo',
        active: 'En curso',
      },
    },

    selectListings: {
      title: 'Listas',
      description: 'Selecciona las listas donde se va a publicar el puesto.',
    },

    session: {
      account: 'Administración de cuentas',
      language: 'Idioma',
      logout: 'Cerrar sesión',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Capacitaciones de Recright',
      expired: 'Por favor, inicia sesión de nuevo.',
      showTutorial: 'Mostrar tutorial',
      helpCenter: 'Recright Help Center',
      organization: 'Organización',
    },

    showFeedbackPulse: {
      showPulse: 'Mostrar valoración',
      positive: avg => `${avg}% positivo`,
      feedbackStatistics: 'Estadísticas de las valoraciones',
      noFeedback: 'Todavía no hay valoraciones',
      responses: responses => `${responses} respuestas`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Tienes ${count} contratación(es) individual(es) en tu cuenta.`,
      notificationBody: 'Al invitar a los candidatos o publicar la entrevista, se utilizará una sola contratación individual.',
    },

    singleHires: {
      currentCount: count => `${count} contratación(es) individual(es) disponible(s).`,
      purchase: 'Comprar una contratación individual',
      label: 'Contratación individual',
      confirmMessage: amount => `Confirma tu compra de contratación individual. ${amount} EUR serán cargados a tu tarjeta de crédito.`,
    },

    smartrecruitersPublish: {
      title: 'Integración de Smartrecruiters',
      description: 'Puedes añadir o eliminar entrevistas personales desde la lista de vídeo entrevistas en Smartrecruiters.',
      notification: 'Ten en cuenta que las entrevistas pueden tardar hasta 24 horas en aparecer en Smartrecruiters.',
      addButton: 'Añadir a Smartrecruiters',
      removeButton: 'Eliminar de Smartrecruiters',
      confirmRemove: '¿Seguro que quieres eliminar la entrevista de Smartrecruiters?',
      addConflict: 'La entrevista ya se ha añadido a la lista de vídeo entrevistas',
      removeConflict: 'La entrevista ya se ha eliminado de la lista de vídeo entrevistas',
    },

    subscriptionExpired: {
      message: 'Tu suscripción ha expirado.',
    },

    subscriptionPlan: {
      plan: 'Plan',
      noActivePlan: 'No tienes ningún plan activo.',
      changePlan: 'Cambiar plan',
      createSubscription: 'Crear una nueva suscripción',
      save: 'Guardar',
      cancel: 'Cancelar',
      errorFromProcessor: error => `El procesador de pagos ha respondido con el siguiente error: ${error}`,
    },

    stars: {
      yourRating: rating => `Tu calificación: ${rating}`,
      totalVotes: count => `${count} valoraciones en total`,
      yourRatingReset: 'Restablece tu voto',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Abierto',
        filled: 'Lleno',
        cancelled: 'Cancelado',
        closed: 'Cerrado',
        draft: 'Borrador',
        hidden: 'Oculto',
        unpublished: 'No publicado',
      },
      person: {
        hired: 'Contratado',
        proceed: 'Proceder',
        new: 'Nuevo',
        videointerviewed: 'Video entrevista',
        personalinterview: 'Entrevista personal',
        withdrawn: 'Descartado',
        scheduledinterview: 'Entrevista programada',
        rejected: 'Rechazado',
      },
    },

    transactionList: {
      noTransactions: 'Sin transacciones',
      createdAt: 'Fecha',
      type: 'Tipo',
      status: 'Estado',
      amount: 'Cantidad',
      receipt: 'Recibo',
      statuses: {
        authorization_expired: 'La autorización ha expirado',
        authorized: 'Autorizado',
        authorizing: 'Autorizando',
        settlement_pending: 'Transacción pendiente',
        settlement_confirmed: 'Transacción confirmada',
        settlement_declined: 'Transacción rechazada',
        failed: 'Error',
        gateway_rejected: 'Puerto rechazado',
        processor_declined: 'Procesador rechazado',
        settled: 'Liquidado',
        settling: 'Liquidando',
        submitted_for_settlement: 'Enviado para la liquidación',
        voided: 'Anulado',
      },
      types: {
        sale: 'Venta',
        credit: 'Crédito',
      },
      download: 'Descargar',
      downloadReceipt: 'Descargar recibo',
      notSettled: 'Esperando liquidación',
    },

    trialBanner: {
      notification: days => `Quedan ${days} días en tu periodo de prueba. Si deseas continuar usándolo después del periodo de prueba, por favor adquiere una suscripción o compra una única contratación.`,
      trialEnded: 'Tu periodo de prueba ya se ha terminado. Por favor adquiere una suscripción o compra una única contratación para continuar utilizando el servicio.',
      orderHere: 'Suscríbete aquí!',
    },

    updateCreditCard: {
      save: 'Guardar',
      cancel: 'Cancelar',
    },

    favorite: {
      popupHeader: 'Seleccionar biblioteca de vídeos',
      yourVideos: 'Tus vídeos',
      companyVideos: 'Vídeos de la empresa',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Pulsa sobre el ícono del corazón para agregar el vídeo a tus favoritos. Para eliminar videos de tus favoritos visita la <a href="${videoLibrary}">Video biblioteca</a>.`,
    },

    brandingPreview: {
      preview: 'Vista previa',
      header: 'Encabezado de ejemplo',
      body: lorem => `Fuente de texto de ejemplo. ${lorem}`,
      linkText: 'Vínculo de ejemplo.',
      primaryButtonText: 'Botón principal',
      secondaryButtonText: 'Botón secundario',
      backButtonText: 'Botón Atrás',
    },

    usersList: {
      generalInformation: 'Información general',
      latestVisit: date => `Última visita: ${date}`,
      neverLogger: 'Nunca ha iniciado sesión',
      externalUser: 'Usuario externo',
      inviteExpired: 'La invitación ha caducado',
      permissions: {
        permissions: 'Permisos',
        seeAllPositions: 'Ver todos los puestos',
        createJobPositions: 'Crear puesto de trabajo',
        createInterviews: 'Crear entrevistas',
        account: 'Editar información de la empresa',
        billing: 'Facturación',
        reporting: 'Informes',
        editUsers: 'Editar usuarios',
        default: 'Permisos por defecto',
      },
      actions: {
        actions: 'Acciones',
        activate: 'Activar',
        deactivate: 'Desactivar',
        removeFromOrganisation: 'Eliminar de la organización',
        hiddenPositions: 'Ocultar puestos',
      },
      noUsers: 'No hay usuarios. Si ha usado filtros en la lista, pruebe a reducir el número de filtros.',
    },

    usersListFilters: {
      sort: {
        name: 'Nombre',
        email: 'Correo electrónico',
        lastAdminAccess: 'Último acceso de administrador',
      },
      find: 'Buscar',
      clearSelections: 'Borrar las selecciones',
      usersCount: count => `Total: ${count} usuarios`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Editar varios usuarios\' permisos',
      deactivateSelectedUsers: 'Desactivar usuarios seleccionados',
      activateSelectedUsers: 'Activar usuarios seleccionados',
      addNewUsers: 'Invitar usuarios',
      save: 'Guardar',
      cancel: 'Cancelar',
      editUsersPermissions: 'Editar usuarios\' permisos',
    },

    linkedInInformation: {
      title: 'Información de LinkedIn:',
      since: 'Desde',
      summary: 'Resumen:',
      fullLinkedInProfile: 'Perfil de Linkedin completo',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Correo electrónico rebotado. Asegúrese de que el destinatario ha recibido su mensaje.',
      },
      Permanent: {
        General: 'Error al entregar el correo electrónico. El proveedor de correo electrónico del destinatario ha rechazado el mensaje.',
        NoEmail: 'La dirección de correo electrónico no existe.',
        Suppressed: 'El correo electrónico no se ha entregado debido a intentos fallidos de entrega previos. ',
      },
      Transient: {
        General: 'Correo electrónico rebotado. Asegúrese de que el destinatario ha recibido su mensaje.',
        MailboxFull: 'La bandeja de entrada del destinatario está llena.',
        MessageTooLarge: 'El contenido del mensaje es demasiado grande.',
        ContentRejected: 'Se ha rechazado el contenido del mensaje.',
        AttachmentRejected: 'Se ha rechazado archivo adjunto .',
      },
    },

    videoBackgroundUpload: {
      header: 'Imagen de fondo del vídeo de la organización',
      description:
        'Imagen que los usuarios de tu organización podrán utilizar como imagen de fondo para los vídeos que graben.',
      add: 'Añadir imagen de fondo del vídeo',
      info: 'El tamaño de imagen recomendado es de 720x480 píxeles.',
    },
  },

  page: {
    account: {
      title: 'Perfil de la organización',
      details: 'Ajustes del perfil de la organización',
      name: 'Nombre de la organización',
      save: 'Guardar',
      saved: 'Información de cuenta guardada.',
      signature: 'Firma',
      permissions: 'Permisos',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Contraseña',
      statistics: 'Statistics',
      organization: 'Organización',
    },

    actionBar: {
      selection: 'seleccionado',
    },

    organisationProfile: {
      title: 'Administración de cuentas',
      details: 'Detalles de la cuenta',
      brandingHeader: 'Marca de la organización',
      name: 'Nombre de la cuenta',
      owner: 'Titular de la cuenta',
      customReplyToSubtitle:
        'Aquí puede editar el nombre del remitente y la dirección de respuesta para las invitaciones a entrevistas. Si estos campos se dejan vacíos, se utilizarán el nombre y el correo electrónico del usuario que envía las invitaciones.',
      customReplyToEmail:
        'Correo electrónico de respuesta para invitaciones a entrevistas',
      customReplyToName:
        'Nombre del remitente para las invitaciones a entrevistas',
      senderInfoDisabled:
        'La actualización de la información del remitente de la invitación a la entrevista está deshabilitada porque las entrevistas en vídeo están deshabilitadas para su organización.',
      slug: 'URL del sitio de empleo',
      slugUnavailable: 'Esta URL ya está reservada.',
      slogan: 'Slogan del sitio de empleo',
      language: 'Idioma del sitio de empleo',
      languagePlaceholder: 'Elegir',
      rss: 'RSS de empleo',
      type: 'Tipo de cuenta',
      types: {
        free: {
          title: 'Gratis',
          description: 'Beneficios gratis\n1 usuario\n1 puesto de trabajo abierto a la vez',
        },
        basic: {
          title: 'Básico',
          description: 'Beneficios de \npuestos de trabajo activos ilimitados gratis \nVideo entrevistas',
        },
        team: {
          title: 'Equipo',
          description: 'Beneficios del equipo\nPuestos de trabajo activos ilimitados\nVideo entrevistas\nPresentaciones de candidatos',
        },
      },
      save: 'Guardar',
      reset: 'Reset',
      saved: 'Se ha guardado la información de la organización.',
      companyAdminUsers: 'Company admin users',
      cancel: 'Cancelar',
      confirmLeave: 'Tienes cambios no guardados. ¿Estás seguro(a) de que quieres irte?',
      error: {
        required: 'Los elementos marcados con * asterisco son obligatorios.',
      },
      emailBrandingHeader: 'Marca de correo electrónico',
      emailBrandingDescription: 'Personalizar los colores de los correos electrónicos enviados a los candidatos.',
    },

    organisationCompetencies: {
      title: 'Competencias de la empresa',
      description: 'Puedes editar, añadir o eliminar las competencias de la empresa aquí. Estas son las competencias por defecto en los nuevos puestos que se creen en esta compañía. Se podrán consultar las competencias de los candidatos de esos puestos en la sección Competencias y compatibilidad.',
    },

    organisationStages: {
      title: 'Fases de contratación de la compañía',
      description: 'Aquí puedes editar, añadir, eliminar y reordenar las fases de contratación de la compañía. Estas son las fases por defecto para las nuevas ofertas de trabajo de esta compañía.',
    },

    organisationEmailTemplates: {
      preview:
        'Vista previa del correo electrónico (la vista previa no tiene incluye el formato del correo electrónico final)',
      preview2:
        'Los colores de las plantillas de correo electrónico se pueden personalizar en la página de configuración de marca de la organización.',
      timedInterviewPreviewInfo:
        'El mensaje de la entrevista con límite de tiempo no contiene la parte relativa al contacto con el servicio de asistencia.',
      templateTypes: {
        interviewInvite: 'Invitación a una entrevista en vídeo',
        timedInterviewInvite: 'Invitación a una entrevista con límite de tiempo',
        interviewCompleted:
          'Entrevista finalizada / mensaje de agradecimiento para los candidatos',
        applicationCompleted: 'Solicitud del anuncio de empleo completada / Mensaje de agradecimiento para el solicitante del anuncio de empleo',
      },
      subHeaders: {
        jobAdLabel: 'Anuncio del puesto',
        interviewLabel: 'Entrevista por vídeo',
      },
      deleteTemplate: 'Eliminar plantilla',
      confirmation: templateName =>
        `¿Está seguro de que desea eliminar la plantilla "${templateName}" de la lista de plantillas de correo electrónico de su organización?`,
      deleteSuccess:
        'La plantilla se ha eliminado de la lista de plantillas de correo electrónico de su organización.',
      emailTemplateInfo: 'En este momento solo se puede guardar una plantilla con un idioma.',
      templateError: 'Template with same name or language already exists.',
    },

    application: {
      back: 'Volver a la lista de solicitudes',
      delete: 'Eliminar solicitud',
      deleted: 'Solicitud eliminada',
      interviewClosed: 'La entrevista está cerrada',
      resendInvitation: 'Reenviar invitación al solicitante',
      changeStage: 'Mover a otra etapa',
      commentsAndClassifications: 'Comentarios y clasificaciones',
      openingTitle: title => `Video entrevista - ${title}`,
      yourRatingText: 'Tu calificación:',
      competencesAndCompatibility: 'Competencias y compatibilidad',
      duplicateCompetency: 'La competencia ya existe',
      competencyNotFound: 'Competencia no encontrada o eliminada',
      confirmDelete: '¿Seguro que quieres eliminar esta solicitud?',
      lastSeen: time => `Visto por última vez ${time}.`,
      stageChanged: '¡Genial!',
      stageChangedInfo: stage => `Ahora que has movido a estos candidatos a la etapa "${stage}", ¡infórmales al respecto! Envíales un correo electrónico o un vídeo mensaje.`,
      close: 'Cerrar',
      reopenProcessConfirm: '¿Seguro que quieres sacar a este candidato de la fase "Descartado" y volver a incorporarlo al proceso de selección? Tras la confirmación, el candidato podrá responder de nuevo a las entrevistas que no haya completado.',
      withdrawConfirm: '¿Seguro que quieres descartar a este candidato del proceso de selección? Si lo descartas, el candidato no podrá responder a las entrevistas a las que haya sido invitado.',
      changestageTooltip: 'Puedes ver la etapa actual en la que se encuentra el candidato. Puedes establecer la etapa de forma manual al hacer clic en la fase deseada. El candidato no recibirá ninguna notificación.',
      commentsTooltip: 'Puedes escribir comentarios sobre la solicitud del candidato para que tus compañeros los vean. El candidato no tiene acceso a esta información.',
      competencesTooltip: 'Puedes añadir o valorar una competencia. Tus compañeros pueden verlo y valorar las competencias que has añadido, además de crear otras nuevas. El candidato no puede ver esta información.',
      actionlogTooltip: 'Aquí aparecerán los comentarios, los cambios de etapa, los mensajes y otras actividades. El candidato no puede ver esta información.',
      stage: {
        new: 'Nuevo',
        hired: 'Contratado(a)',
        proceed: 'Proceder',
        personalinterview: 'Entrevista personal',
        withdrawn: 'Descartado',
        scheduledinterview: 'Entrevista programada',
        rejected: 'Rechazado',
        videointerviewed: 'Video entrevista',
      },
      state: {
        invited: 'Invitado',
        visited: 'Visitado',
        incomplete: 'Incompleto',
        completed: 'Completado',
      },
      notVisited: 'No ha visitado en la entrevista.',
    },

    billing: {
      title: 'Facturación',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `La siguiente facturación será ${nextBillingPeriodAmount} EUR el ${nextBillingDate}`,
      status: 'Estado',
      singleHire: 'Contratación individual',
      billingOverview: 'Resumen de facturación',
      payment: 'Pago',
      paymentHistory: 'Historial del pagos',
      updateDetails: 'Actualizar detalles de facturación',
      billingStatus: {
        pending: 'Pendiente',
        active: 'Activo',
        pastdue: 'Adeudo',
        expired: 'Caducado',
        canceled: 'Cancelado',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Registro de acciones',
      back: 'Volver a la lista de candidatos',
      delete: 'Eliminar candidato',
      deleted: 'Candidate eliminado',
      interviewClosed: 'La entrevista está cerrada. No se enviaron invitaciones nuevas.',
      resendInvitation: 'Reenviar invitación al candidato',
      changeStage: 'Mover a otra etapa',
      introducedTo: 'Introducido en:',
      yourRatingText: 'Tu calificación:',
      competencesAndCompatibility: 'Competencias y compatibilidad',
      duplicateCompetency: 'La competencia ya existe',
      competencyNotFound: 'Competencia no encontrada o eliminada',
      confirmDelete: '¿Seguro que quieres eliminar a este candidato?',
      stageChanged: '¡Genial!',
      stageChangedInfo: stage => `Ahora que has movido a estos candidatos a la etapa "${stage}", ¡infórmales al respecto! Envíales un correo electrónico o un vídeo mensaje.`,
      close: 'Cerrar',
      hideStages: 'Ocultar etapas',
      showStages: 'Mostrar etapas',
      resetQuestionResponseSuccess: 'Se eliminó la respuesta del candidato',
      stage: {
        new: 'Nuevo',
        hired: 'Contratado(a)',
        proceed: 'Proceder',
        personalinterview: 'Entrevista personal',
        withdrawn: 'Descartado',
        scheduledinterview: 'Entrevista programada',
        rejected: 'Rechazado',
        videointerviewed: 'Video entrevista',
      },
    },

    dashboard: {
      upcomingLiveInterviews: 'Entrevistas en vivo',
      showAllLiveInterviews: 'Mostrar todas las entrevistas en vivo',
      createNewLiveInterview: 'Crear nueva entrevista en vivo',
      welcome: name => `Bienvenido(a), ${name}!`,
      liveCard: {
        startTime: 'Hora de inicio',
        interviewers: 'Entrevistadores',
        candidates: 'Candidatos',
      },
    },

    interviewEdit: {
      title: 'Escribe el título de la entrevista',
      titleLabel: 'Título de la entrevista',
      location: 'Ubicación',
      publishTimePlaceholder: 'Publicar fecha',
      publishTimeTooltip: 'Fija una fecha de publicación para la entrevista. Podrás cambiar la fecha en cualquier momento.',
      endTime: 'Abierta hasta',
      endTimeTooltip: 'Selecciona una fecha de finalización para el período de solicitudes.',
      timezone: 'Zona horaria',
      isNotPastDate: 'La fecha ya ha pasado.',
      interviewIsClosed: 'La entrevista está cerrada actualmente. ¿Desea ',
      interviewIsClosedLink: 'abrirla?',
      edit: {
        details: 'Editar entrevista',
        status: 'Cambiar estado de la entrevista',
        team: 'Editar equipo',
      },
      questions: 'Preguntas de la entrevista',
      answerable: 'La pregunta puede ser respondida',
      questionsDescription: 'Estas son las preguntas que se les pide a los participantes que respondan.',
      questionsNotEditable: 'Las preguntas no se pueden editar después de enviar las invitaciones.',
      saved: 'Entrevista guardada',
      deleted: 'Entrevista eliminada',
      delete: 'Eliminar entrevista',
      cancel: 'Cancelar',
      save: 'Guardar',
      language: 'Idioma de la entrevista',
      languagePlaceholder: 'Elegir',
      languages: {
        en: 'English',
        fi: 'Finnish',
      },
      confirmLeave: 'Tienes cambios no guardados. ¿Estás seguro(a) de que quieres irte?',
      OnboardingHeadImageSize: 'El tamaño recomendado para la imagen del banner de la cabecera es de 1440px*320px o mayor.',
      takeLimitLabel: 'Número de tomas',
      answerTimeLabel: 'Tiempo de respuesta',
      preparationTimeLabel: 'Tiempo de preparación',
      confirmHeader: '¿Está seguro de que desea eliminar esta entrevista?',
      integratedConfirmContent: 'Esta entrevista está integrada en otro sistema y, al eliminarla, se podrán producir problemas con la integración.',
    },

    interview: {
      endTime: date => (date ? `hasta ${date}` : ''),
      edit: 'Editar entrevista',
      editTeam: 'Editar equipo',
      questions: 'Preguntas de la entrevista',
      changeStatus: 'Cambiar estado de la entrevista',
      publishSettings: 'Publicando propiedades',
      invite: 'Invitar a los candidatos',
      showCandidates: 'Mostrar candidatos',
      oneError: ' La entrevista insertada solo puede tener una pregunta.',
      copySuccess: 'La entrevista se ha copiado con éxito',
      editMenu: 'Editar',
      copy: 'Copiar entrevista',
      editInvitation: 'Editar mensaje de invitación',
      editIntroduceBatches: 'Editar presentaciones',
      editEmailSettings: 'Editar configuración de correo electrónico',
    },

    interviews: {
      allInterviews: 'Todas las video entrevistas',
      createNewVideoInterview: 'Crear nueva video entrevista',
      filter: 'Buscar entrevistas',
      invites: 'Invitaciones',
      responses: 'Respuestas',
      sort: {
        title: 'Título',
        endTime: 'Fecha de finalización',
        publishTime: 'Publicar fecha',
        createdAt: 'Fecha de creación',
        updatedAt: 'Última modificación',
        answeredCount: 'Candidatos',
      },
    },

    interviewCandidates: {
      preview: 'Vista previa',
      endTime: date => (date ? `Abierto hasta ${date}` : ''),
      publicTitle: 'Entrevista pública',
      embedTitle: 'Entrevista insertada',
      placeholder: {
        first: 'No hay candidatos todavía.',
        second: 'También puedes hacer pública tu video entrevista.',
        third: 'Entonces todos los interesados en el puesto pueden ver la entrevista y postularse.',
        fourth: 'No olvides que todos estos están a un solo botón de distancia en la barra de título de arriba.',
      },
      title: 'Todos los candidatos',
      sort: {
        default: 'Predeterminado',
        updatedAt: 'Última modificación',
        name: 'Nombre',
        rating: 'Calificación',
        createdAt: 'Fecha de creación',
      },
      sendMessage: 'Enviar mensaje',
      changeStage: 'Mover a otra etapa',
      introduce: 'Presentar',
      filter: 'Buscar candidatos',
      hideFilters: 'Ocultar filtros',
      showFilters: 'Mostrar filtros',
      emailSent: '¡Mensaje enviado!',
      interviewClosedError: 'No puedes volver a invitar a un candidato a una vídeo entrevista que está cerrada.',
      excel: 'Exportar a todos los candidatos',
      reInviteSent: candidates => `¡${candidates} reinvitaciones enviadas!`,
    },

    jobAdEdit: {
      preview: 'Vista previa',
      confirm: '¿Estás seguro(a) de que quieres agregar este puesto?',
      deleteHeader: '¿Estás seguro(a) de que deseas eliminar este puesto?',
      deleteContent: 'Al eliminar este trabajo, también se eliminará toda la información relacionada con el puesto de trabajo, como las solicitudes o las entrevistas en vídeo.',
      titlePlaceholder: 'Título del puesto',
      locationPlaceholder: 'Ubicación',
      endTimePlaceholder: 'Abierta hasta',
      endTimeTooltip: 'Selecciona una fecha de finalización para el período de solicitudes.',
      timezone: 'Zona horaria',
      isNotPastDate: 'la fecha ya ha pasado.',
      publishTimePlaceholder: 'Publicar fecha',
      publishTimeTooltip: 'Establece una fecha de publicación para la oferta de trabajo. Puedes modificar la fecha en cualquier momento.',
      language: 'Idioma',
      languagePlaceholder: 'Elegir',
      languages: {
        en: 'English',
        fi: 'Finnish',
      },
      description: 'Descripción del puesto',
      saved: 'Puesto de trabajo guardado',
      deleted: 'Puesto eliminado',
      descriptionPlaceholder: 'Escribe la descripción de tu trabajo aquí. \n\n Puedes enriquecer la descripción con las herramientas de modificación de texto de arriba.',
      createInviteOnly: 'Crear video entrevista solo para invitación',
      delete: 'Eliminar puesto',
      cancel: 'Cancelar',
      save: 'Guardar',
      confirmLeave: 'Tienes cambios no guardados. ¿Estás seguro(a) de que quieres irte?',
      singleHireEndError: 'La contratación individual no se puede usar más de 60 días.',
      OnboardingHeadImageSize: 'El tamaño recomendado para la imagen del banner de la cabecera es de 1440px*320px o mayor.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, abierto hasta ${date}` : ''),
      title: 'Todas las solicitudes',
      sort: {
        updatedAt: 'Última modificación',
        name: 'Nombre',
        rating: 'Calificación',
        createdAt: 'Fecha de creación',
      },
      add: 'Agregar nuevo candidato',
      inviteToInterview: 'Invitar a la entrevista',
      sendMessage: 'Enviar mensaje',
      changeStage: 'Mover a otra etapa',
      introduce: 'Presentar',
      editIntroduceBatches: 'Editar presentaciones',
      filter: 'Buscar solicitudes',
      hideFilters: 'Ocultar filtros',
      showFilters: 'Mostrar filtros',
      addInterviewConfirm: jobAd => `¿Quieres crear un nuevo vídeo de entrevista adjunto al puesto de trabajo "${jobAd}" ?`,
    },

    adminJobAdApplication: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Número telefónico',
      city: 'Ciudad',
      applyForPosition: 'Postularse a la vacante',
      back: 'Atrás',
      continue: 'Continuar',
      submit: 'Agregar',
      saveForLater: 'Continuar después',
      cityPlaceholder: 'Ciudad',
      namePlaceholder: 'Nombre del candidato',
      emailPlaceholder: 'Correo electrónico del candidato',
      links: 'Añadir enlaces, por ejemplo, al perfil de LinkedIn',
      legendLinks: 'Enlaces',
      legendAttachments: 'Adjuntos',
      legendAdditionalFields: 'Información adicional',
      legendBasicInfo: 'Información básica',
      coverLetter: 'Carta de presentación',
      attachments: 'Adjuntos',
      introduction: 'Escribe aquí una breve introducción tuya',
      readyInfo: 'Gracias. El candidato se ha añadido al puesto de trabajo.',
      close: 'Cerrar',
      required: 'Los elementos marcados con * asterisco son obligatorios.',
      excel: 'Exportar todas las solicitudes',
    },

    jobAdPreview: {
      endTime: date => (date ? `, abierta hasta ${date}` : ''),
      exit: 'Salir de vista previa',
      description: 'Descripción del empleo',
      video: 'Video del empleador',
      questions: 'Video pregunta',
      apply: 'Postularse a la vacante',
    },

    jobAd: {
      endTime: date => (date ? `, abierta hasta ${date}` : ''),
      changeStatus: 'Cambiar estado del puesto de trabajo',
      edit: 'Editar puesto de trabajo',
      editTeam: 'Editar equipo',
      description: 'Descripción del empleo',
      video: 'Video del empleador',
      questions: 'Video pregunta',
      apply: 'Postularse a la vacante',
      showApplications: 'Mostrar solicitudes',
      publicLink: 'Página pública del anuncio de trabajo',
      copySuccess: 'El puesto de trabajo se ha copiado con éxito',
      editMenu: 'Editar',
      copy: 'Copiar puesto de trabajo',
      editInvitation: 'Editar mensaje de invitación',
    },

    jobAds: {
      subscriptionNeeded: 'Necesitas una suscripción activa para publicar este puesto de trabajo.',
      responses: 'Solicitudes',
      createNewJobPosition: 'Crear nuevo puesto de trabajo',
      allJobPositions: 'Todos los puestos de trabajo',
      confirmSingleHire: 'Una de las contrataciones individuales adquiridas se usa para este puesto de trabajo.',
      filter: 'Buscar puestos de trabajo',
      sort: {
        title: 'Título',
        publishTime: 'Publicar fecha',
        applicationCount: 'Solicitudes',
        endTime: 'Fecha de finalización',
        createdAt: 'Fecha de creación',
        updatedAt: 'Última modificación',
      },
    },

    jobAdSaved: {
      title: '¡Puesto de trabajo guardado!',
      description: 'Tu anuncio de trabajo ahora está guardado. Aquí hay un enlace público del anuncio de trabajo: ',
      addApplication: 'Enlace directo al formulario de solicitud:',
      toDashboard: 'Página principal',
      toJobAd: 'Volver al anuncio de trabajo',
    },

    live: {
      title: 'Entrevista en vivo',
      editTitle: 'Editar entrevista en vivo',
      startTimeTitle: 'Hora de inicio de la entrevista',
      startTime: 'Hora de inicio',
      interviewers: 'Entrevistadores',
      candidates: 'Candidatos',
      messageLabel: 'Mensaje de invitación',
      create: 'Crear',
      save: 'Guardar cambios',
      cancel: 'Cancelar',
      removeLive: 'Eliminar entrevista en vivo',
      cancelLive: 'Cancelar entrevista en vivo',
      comment: 'Agregar un nuevo comentario',
      commentLabel: 'Comentarios',
      enter: 'Ingresa la entrevista en vivo',
      edit: 'Agregar / eliminar participantes',
      draft: 'Nueva entrevista en vivo',
      confirmHeader: '¿Está seguro de que desea eliminar esta entrevista?',
      inviteFailure: (success, failed) => `${success} invitación(es) enviada(s) y ${failed} ha(n) fallado!`,
      inviteSuccess: success => `${success} invitación(es) enviada(s).`,
      success: {
        create: 'Nueva entrevista en vivo creada',
        delete: 'Entrevista en vivo eliminada',
        update: 'Entrevista en vivo actualizada',
      },
      placeholders: {
        candidateEmails: 'Agregar candidato',
        interviewerEmails: 'Agregar entrevistador',
        emailTitle: 'Título',
        emailMessage: 'Mensaje',
      },
    },

    lives: {
      allLives: 'Todas las entrevistas en vivo',
      createNewLive: 'Crear una nueva entrevista en vivo',
      filter: 'Buscar por candidatos',
      candidates: 'Candidatos',
      sort: {
        title: 'Título',
        startTime: 'Hora de inicio',
        createdAt: 'Fecha de creación',
      },
    },

    login: {
      title: 'Iniciar sesión en el servicio',
      register: 'Registrarse',
      ldap: 'Iniciar sesión con integración LDAP',
      forgot: '¿Has olvidado la contraseña?',
      normal: 'Inicio de sesión normal',
      ssoLogin: 'Inicio de sesión SSO',
    },

    publicSubscribe: {
      intro: 'Elije un plan adecuado, completa los detalles de tu pago y usa la herramienta de reclutamiento con video de inmediato. Todos tus pagos son procesados de forma segura por nuestro procesador de pagos Braintree.',
      headline: 'Formulario de suscripción',
      header: {
        back: 'Back',
      },
      footer: {
        product: 'Product',
        pricing: 'Pricing',
        resources: 'Resources',
        contact: 'Contact',
        terms: 'User Terms and Conditions',
        privacyPolicy: 'Privacy policy',
        license: 'General Terms of Service',
      },
    },

    publicSubscribeThankYou: {
      title: '¡Gracias!',
      existingDescription: 'Ahora hemos recibido la información de suscripción y puedes continuar utilizando la herramienta de reclutamiento con videos.',
      newUserDescription: 'Hemos creado una cuenta para ti y hemos enviado un correo electrónico sobre cómo configurar tu contraseña.',
    },

    quickInterview: {
      title: 'Video entrevista rápida',
      description: 'Para conocerte más rápido, nos gustaría que respondas brevemente a nuestra pregunta de entrevista rápida. Saca tu personalidad y dale vida a tu solicitud.',
      requiredNote: 'Toma en cuenta que esta es una parte del proceso de solicitud, y el recruiter recibirá tu solicitud solo después de que hayas registrado tu respuesta.',
      reminderNote: 'Puedes registrar tu respuesta de inmediato, o puedes continuar más tarde al recibir un recordatorio en tu correo electrónico.',
    },

    register: {
      title: '¡Diseñado para el personal de selección y contratación!',
      leadText: 'Recright es una sencilla plataforma de contratación con vídeos para el personal de selección y contratación. Puedes publicar ofertas de trabajo, recibir solicitudes y realizar vídeo entrevistas, ¡todo en la misma plataforma! Nuestra herramienta ha ayudado a más de 400 compañías a encontrar al personal adecuado, ¡tu compañía podría ser la siguiente! ¡Regístrate y empieza a contratar!',
      email: 'Correo electrónico',
      submit: 'Registrarse',
      alreadyMember: '¿Ya eres miembro?',
      onlyForRecruiters: 'Este registro es solo para el personal de selección y contratación.',
      login: 'Inicia sesión aquí.',
      registerSuccess: 'Verifica tu correo electrónico y regístrate a través del enlace que te hemos enviado.',
      domainError: 'Regístrese con la dirección de correo electrónico de su empresa.',
      companyExistsMessage: '¡Para más información, consulte su correo electrónico!',
    },

    welcome: {
      title: 'Registro',
    },

    welcomeMulticompany: {
      welcome: companyName => `Bienvenido a ${companyName}`,
      successMessage: companyName =>
        `Se le ha añadido a la organización ${companyName}!`,
      navigationInfo:
        'Puede cambiar su organización actual desde la barra de navegación en la parte superior derecha.',
      login: 'Inicia sesión aquí',
    },

    forgotPassword: {
      title: 'Establecer una nueva contraseña',
      email: 'Correo electrónico',
      submit: 'Enviar',
      sendEmail: 'Envíanos la dirección de correo electrónico que has utilizado para registrarte en Recright.',
      instructions: 'Te enviaremos instrucciones sobre cómo cambiar tu contraseña.',
      success: 'Si se ha encontrado al usuario con la dirección de correo electrónico proporcionada, las instrucciones para cambiar la contraseña se habrán enviado a esa dirección.',
    },

    changePassword: {
      title: 'Estableciendo tu contraseña',
      name: 'Nombre',
      email: 'Correo electrónico',
      password: 'Nueva contraseña',
      confirmPassword: 'Nueva contraseña otra vez',
      submit: 'Cambiar contraseña',
      error: {
        password: {
          isRequired: 'La contraseña es obligatoria. ',
          isValidPassword: 'Las contraseñas válidas deben tener un mínimo de 12 caracteres, incluyendo al menos una letra en mayúsculas, una letra en minúsculas y un número.',
          passwordsMatch: 'Las contraseñas no coinciden. ',
        },
      },
    },

    searchResults: {
      title: 'Buscar resultados',
      applications: 'Solicitudes',
      candidates: 'Candidatos',
      noApplications: 'No hay solicitudes que coincidan con los criterios de búsqueda',
      noCandidates: 'No hay candidatos que coincidan con los criterios de búsqueda',
      query: query => (query ? `Término de búsqueda: ${query}` : ''),
      noStage: 'Aún en ninguna etapa',
      search: 'Buscar',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Título',
        owner: 'Owner',
        createdAt: 'Fecha de creación',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    ssoLogin: {
      title: 'Inicio de sesión SSO',
      description: 'Inicie sesión con las credenciales de su organización.',
      info: 'Autenticación externa no configurada. Por favor, utilice el inicio de',
      normalLoginLinkText: 'sesión normal.',
      submit: 'Iniciar sesión en el servicio',
    },

    subscribe: {
      title: 'Suscribir',
      submit: 'Enviar',
      creditCard: 'Tarjeta de crédito',
      cvv: 'CVV',
      expirationDate: 'Fecha de vencimiento',
      vatAdvice: 'Al proporcionar el código del IVA, no te cobraremos el impuesto al valor agregado',
      vatId: 'IVA / Clave de impuestos',
      vatHelp: 'Proporciona tu clave de IVA en formato internacional, incluido el código de país.',
      includeVat: 'incl. IVA',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      company: 'Compañía',
      street: 'Calle',
      postalCode: 'Código postal',
      city: 'Ciudad',
      country: 'País',
      emptyCardFields: 'Completa los datos de tu tarjeta de crédito',
      invalidValue: 'El valor del campo es inválido.',
      planNotSelected: 'Por favor, selecciona un plan',
      totalPrice: 'Total',
      subscribed: '¡Excelente! Tu suscripción ha sido creada.',
      subscriptionExists: 'Tu empresa parece tener una suscripción activa. Por favor inicia sesión para cambiar tu suscripción.',
      agreeTos: 'He leído y acepto los ',
      agreeTosLinkText: 'Términos y Condiciones de Uso de Recright.',
      privacyPolicy: 'Valoramos su privacidad, por favor lea nuestra ',
      privacyPolicyLinkText: 'Política de Privacidad.',
      licenseAgreement: 'En nombre de la organización que represento, acepto las ',
      licenseAgreementLinkText: 'Condiciones Generales de Servicio Recright.',
      newsletter: 'Suscribirse al boletín mensual.',
      neverExpiresDiscount: amount => `Incluyendo descuento de por vida ${amount}`,
      fixedPeriodDiscount: (amount, cycles) => `Incluyendo descuento ${amount} for ${cycles} meses`,
      errorFromProcessor: error => `El procesador de pagos ha respondido con el siguiente error: ${error}`,
    },

    videos: {
      yourVideos: 'Tus vídeos',
      companyVideos: 'Vídeos de la empresa',
      title: 'Video biblioteca',
      add: 'Crear nuevo video',
      rename: 'Renombrar',
      remove: 'Eliminar',
      sort: {
        createdAt: 'Fecha de creación',
        title: 'Título',
      },

    },

    userManagement: {
      excel: 'Exportar todos los usuarios',
      title: 'Gestión de usuarios',
      showCompanyDefaultPermissions: 'Mostrar permisos por defecto de la empresa',
      activateUserConfirm: '¿Seguro que quiere activar este usuario?',
      deactivateUserConfirm: '¿Seguro que quiere desactivar este usuario?',
      showActivatedUsers: 'Mostrar usuarios activados',
      showDeactivatedUsers: 'Mostrar usuarios desactivados',
      confirmCancelEditPermissions: {
        message: 'No ha guardado los cambios. ¿Seguro que quiere descartar todos los cambios?',
        cancel: 'Cancelar',
        confirm: 'Descartar cambios',
      },
      unsavedChanges: 'No ha guardado los cambios. ¿Quiere guardar estos cambios?',
      confirm: 'Guardar',
      permissionsChangesSaved: '¡Se han cambiado los permisos de los usuarios correctamente!',
      userDeactivated: nameOrEmail => `${nameOrEmail} desactivado`,
      userActivated: nameOrEmail => `${nameOrEmail} activado`,
      companyDefaultsSaved: '¡Se han cambiado los permisos de administrador por defecto correctamente!',
      usersAddAdded: success => ` Se han añadido ${success} usuarios.`,
      usersAddExist: exist => ` ${exist} usuarios ya están en Recright.`,
      excel: 'Exportar todos los usuarios',
    },

  },

}
